module.exports = __webpack_public_path__ + "img/tshirt1.de5e4fc5.jpg";